import { whatsappService } from "@/_services";

export const whatsapp = {
  namespaced: true,
  state: {
    detail: {
      data: null,
      status: {},
    },
  },
  mutations: {
    getWhatsappChatByIdRequest(state) {
      state.detail.status = {
        loading: true,
      };
    },
    getWhatsappChatByIdSuccess(state, response) {
      state.detail.data = response;
      state.detail.status = {
        loaded: true,
      };
    },
    getWhatsappChatByIdError(state, error) {
      state.detail.data = null;
      state.detail.status = {
        error,
      };
    },
    clearWhatsappChatById(state) {
      state.detail.data = null;
      state.detail.status = {};
    },
  },
  actions: {
    getWhatsappChatById({ commit }, whatsappId) {
      commit("getWhatsappChatByIdRequest");
      return whatsappService
        .getWhatsappChatById(whatsappId)
        .then((response) => {
          commit("getWhatsappChatByIdSuccess", response);
          return response;
        })
        .catch((error) => {
          commit("getWhatsappChatByIdError", error);
          throw error;
        });
    },
    clearWhatsappChatById({ commit }) {
      commit("clearWhatsappChatById");
    },
  },
};
